import {TextUtilsService} from '../services/textUtils.service';
import {CameraLayers} from '../enum/CameraLayers';

declare let THREE: any;

interface SpriteConfig {
  width: number;
  height: number;
  label: string;
  anisotropy: number;
}

const createPlaneGeometry = function (width: number, height: number) {
  const geometry = new THREE.PlaneBufferGeometry(width, height);
  geometry.rotateX(THREE.Math.degToRad(-90));
  return geometry;
};

const createLabel = function (text: string, anisotropy: number) {

  const fontSize = 18;

  const image = TextUtilsService.textToImage(text, {
    width: 256,
    height: 32,
    fontSize
  });

  const textWidth = TextUtilsService.getTextWidth(text, {
    fontSize,
    font: 'Arial'
  });

  const mesh = new THREE.Mesh(
    createPlaneGeometry(textWidth, 24),
    new THREE.MeshBasicMaterial({map: new THREE.Texture(image), depthTest: false, transparent: true})
  );

  mesh.layers.set(CameraLayers.SPRITE_2D);
  mesh.renderOrder = 2;
  mesh.material.map.anisotropy = anisotropy;
  mesh.material.map.needsUpdate = true;
  mesh.material.needsUpdate = true;
  mesh.name = 'Label';
  return mesh;
};

export class Sprite2D extends (THREE.Mesh as { new(geometry, material): any; }) {

  constructor(config: SpriteConfig) {

    super(
      createPlaneGeometry(config.width, config.height),
      new THREE.MeshBasicMaterial({depthTest: false})
    );

    this.layers.set(CameraLayers.SPRITE_2D);

    this.add(createLabel(config.label, config.anisotropy));

    this.name = 'Sprite2D';
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/Sprite2D.ts